import React, { useEffect, useRef, useState } from 'react';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import shemLogo from "../assets/img/shemm-white.png";
import Timer from "./Timer.js";
import ManagerMenu from "./ManagerMenu.js";
import MyImgRound from "./MyImgRound.js";
import { managerProfileRequest } from "../store/actions/manager.js";
import { Link } from "react-router";
import Settings from "./Mydata/Settings/Settings.js";
import Left from "./Left.js";
import { Row } from "react-bootstrap";
import Cookies from 'js-cookie'
import TaskMessage from "./TaskMessage.js";
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationModal from "./NotificationModal.js";
import { notificationRequest } from "../store/actions/notification.js";
import { accountantRequest, taskManagerRequest } from "../store/actions/task.js";
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import Chat from './Chats/Chat.js';
import AgentTimer from './Agents/AgentTimer.js';

function Wrapper({ children }) {
    const dispatch = useDispatch();
    const employee = useSelector((state) => state.manager.employee);
    const taskMessage = useSelector((state) => state.task.taskMessage);
    const taskSocket = useSelector((state) => state.notification.taskSocket);
    const dayoffSocketSetter = useSelector((state) => state.notification.dayoffSocketSetter);
    const notificationSocketSetter = useSelector((state) => state.notification.notificationSocketSetter);
    const dayoffMessage = useSelector((state) => state.dayoff.dayoffMessage);
    const surveyMessage = useSelector((state) => state.dayoff.surveyMessage);
    const data = useSelector((state) => state.notification.notifyData);
    const modalRef = useRef(null);
    const chatRef = useRef(null);
    const [showNote, setShowNote] = useState(false);
    const [showChat, setShowChat] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {

            if ((modalRef.current && !modalRef.current.contains(event.target))) {
                setShowNote(false);
            }
            if ((chatRef.current && !chatRef.current.contains(event.target))) {
                setShowChat(false);
            }
        }

        if (showNote) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        if (showChat) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showNote,showNote]);

    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [menu, setMenu] = useState(false);
    useEffect(() => {
        (async () => {
            await dispatch(accountantRequest())
            await dispatch(taskManagerRequest())
        })();
    }, []);
    const errorNotify = () =>
        toast.error("Չhաջողվեց բեռնել կազմակերպությունները, խնդրում ենք թարմացնել կայքը", {
            position: "top-center",
        });

    // Fetch user data
    useEffect(() => {
        (async () => {
            await dispatch(managerProfileRequest({ prof: Cookies.get('profession'), id: Cookies.get('id') }))
            await dispatch(notificationRequest())

        })()

    }, []);

    return (
        <div className="manager-container">
            {showSettings && (
                <>
                    <div className="popup" onClick={() => setShowSettings(false)} />
                    <Settings close={() => setShowSettings(false)} />
                </>
            )}


            {menu &&
                <div className="hidden-sheet"
                    onClick={() => setMenu(!menu)}
                />
            }

            <div className="manager-header">
                <div className="container">
                    <div className="nav-bar">
                        <a className="logo">
                            {process.env.REACT_APP_SERVER !== 'PEK' && (
                                <img src={shemLogo} alt="logo" />
                            )}
                        </a>

                        <div className="nav-bar-left d-flex align-items-center">
                            {menu ?
                                <ManagerMenu />
                                : <span className="icon-Menu" onClick={() => setMenu(!menu)} />}

                            <div className="my-img-cont">
                                <Link to="/main_employee/mypage">
                                    <MyImgRound image={employee?.image} />
                                    <div className="my-name">
                                        {employee?.url || employee?.user?.id ? `${employee.user.first_name} ${employee.user.last_name}` : "loading..."}
                                        <div className="menu-line" />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <span
                                            className="my_round"
                                            style={
                                                taskSocket === "off" && dayoffSocketSetter === 'off' && notificationSocketSetter === 'off' ?
                                                    { background: 'red' } :
                                                    taskSocket === "on" && dayoffSocketSetter === 'on' && notificationSocketSetter === 'on' ?
                                                        { background: '#68ff2b' } :
                                                        { background: 'orange' }} />
                                        {localStorage.getItem('profession') === "agent"? <AgentTimer/> :<Timer />}
                                    </div>


                                </Link>

                                <div className="nav-item" onClick={() => setShowSettingsModal(!showSettingsModal)}>
                                    <div className="dropdown-cont" />
                                    {showSettingsModal && (
                                        <div className="dropdown-hover-none">
                                            <div className="nav-item">
                                                <Link to="/main_employee/mypage">Անձնական հաշիվ</Link>
                                            </div>
                                            <div className="nav-item">
                                                <div onClick={() => setShowSettings(true)}>էջի կարգավորումներ</div>
                                            </div>
                                            <div className="nav-item">
                                                <div onClick={() => {
                                                    localStorage.clear();
                                                    window.location = "/employee";
                                                }}>
                                                    Դուրս գալ
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="notify-parent position-relative">
                                    {data.length ? <span className="position-absolute notify">{data.length}</span> : null}
                                    <NotificationsIcon onClick={() => setShowNote(!showNote)} style={{ color: 'white', fontSize: 30, cursor: 'pointer' }} />
                                    {showNote && <div ref={modalRef}>
                                        <NotificationModal />
                                    </div>}
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
            <div className='manager-main'>
                <div className='container'>
                    <Row className="flex-nowrap">
                        {window.innerWidth <= 1200 ? null : <Left />}

                        <div className='right'>
                            {children}
                        </div>
                    </Row>
                </div>
            </div>
            <div className="header-line" />
            <TaskMessage message={taskMessage} />
            <TaskMessage message={dayoffMessage} type="dayoff" text="BeOn Day Off Notification" />
            <TaskMessage message={surveyMessage} type="survey" text="BeOn նոր հարցում" />
            <div className='chatIcon' ref={chatRef}>
                <ChatBubbleIcon onClick={() => setShowChat(prev => !prev)}/>
                <Chat visible={showChat}/>
            </div>
        </div>
    );
}

export default Wrapper;